const DEFAULT_SENTRY_FEATURE_TAG = 'root';
const sentryFeatureTagOverrides: string[] = [];

const normalizeSentryFeatureTag = (featureTag: string | null | undefined): string | undefined => {
  if (!featureTag) {
    return undefined;
  }

  const normalizedFeatureTag = featureTag.trim();
  return normalizedFeatureTag.length > 0 ? normalizedFeatureTag : undefined;
};

const getPathnameFeatureTag = (pathname: string): string => {
  const featureSegment = pathname
    .split('/')
    .map((segment) => segment.trim())
    .find((segment) => segment.length > 0);

  return featureSegment ?? DEFAULT_SENTRY_FEATURE_TAG;
};

export const pushSentryFeatureTagOverride = (featureTag: string): void => {
  const normalizedFeatureTag = normalizeSentryFeatureTag(featureTag);

  if (!normalizedFeatureTag) {
    return;
  }

  sentryFeatureTagOverrides.push(normalizedFeatureTag);
};

export const popSentryFeatureTagOverride = (featureTag: string): void => {
  const normalizedFeatureTag = normalizeSentryFeatureTag(featureTag);

  if (!normalizedFeatureTag) {
    return;
  }

  const overrideIndex = sentryFeatureTagOverrides.lastIndexOf(normalizedFeatureTag);

  if (overrideIndex >= 0) {
    sentryFeatureTagOverrides.splice(overrideIndex, 1);
  }
};

export const clearSentryFeatureTagOverrides = (): void => {
  sentryFeatureTagOverrides.length = 0;
};

export const resolveSentryFeatureTag = (pathname: string): string => {
  return sentryFeatureTagOverrides.at(-1) ?? getPathnameFeatureTag(pathname);
};
